import { IIconProps } from "../types"

export default function IconLL6(props: IIconProps) {
  const width = props.size || props.width || 93
  const height = props.size || props.height || 72
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 93 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.2523 8.19922C85.6224 5.39922 83.4124 3.63922 80.3824 2.39922C77.3523 1.15922 73.5124 0.449219 69.7724 0.449219C66.0224 0.449219 62.3824 1.15922 58.9624 2.03922C55.5424 2.91922 52.3524 3.95922 49.1624 4.51922C45.9724 5.06922 42.7824 5.13922 39.5624 4.83922C36.3424 4.54922 33.0824 3.89922 30.2224 3.30922C27.3524 2.72922 24.8824 2.20922 22.1424 2.33922C19.4124 2.46922 16.4224 3.24922 13.5524 4.28922C10.6924 5.32922 7.95235 6.62922 5.64235 8.32922C3.33235 10.0192 1.44235 12.0992 0.762354 18.6792C0.0723535 25.2492 0.592354 36.3192 1.64235 44.7192C2.68235 53.1192 4.24235 58.8492 6.06235 62.1392C7.89235 65.4192 9.97235 66.2692 14.0124 67.0492C18.0424 67.8292 24.0324 68.5492 32.5024 69.2592C40.9624 69.9792 51.9024 70.6992 59.5824 70.6992C67.2624 70.6992 71.6924 69.9792 74.9824 68.9392C78.2624 67.8992 80.4124 66.5292 82.3024 63.9292C84.1924 61.3192 85.8223 57.4792 87.4824 51.8492C89.1423 46.2192 90.8324 38.7992 91.4223 32.9692C92.0023 27.1392 91.4824 22.9092 90.7024 18.8692C89.9223 14.8392 88.8824 10.9892 87.2523 8.19922Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M41.1922 4.95898C40.6622 15.589 40.1222 26.209 40.0922 31.689C40.0522 37.169 40.5022 37.489 43.1722 39.349C45.8422 41.199 50.7222 44.589 55.6122 47.969"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M40.362 36.0996C35.352 38.9496 30.342 41.7996 25.332 44.6496"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
